import { render } from "./EditWordDialog.vue?vue&type=template&id=62b731b2&scoped=true"
import script from "./EditWordDialog.vue?vue&type=script&lang=js"
export * from "./EditWordDialog.vue?vue&type=script&lang=js"

import "./EditWordDialog.vue?vue&type=style&index=0&id=62b731b2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b731b2"]])

export default __exports__